// generic messages
export const INIT = 'INIT';
export const LOADED = 'LOADED';

// Token related
export const GET_TOKEN = 'GET_TOKEN';
export const GET_TOKEN_PENDING = 'GET_TOKEN_PENDING';
export const GET_TOKEN_ERROR = 'GET_TOKEN_ERROR';
export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';

export const GET_DECODED_TOKEN_PENDING = 'GET_DECODED_TOKEN_PENDING';
export const GET_DECODED_TOKEN_SUCCESS = 'GET_DECODED_TOKEN_SUCCESS';
export const GET_DECODED_TOKEN_ERROR = 'GET_DECODED_TOKEN_ERROR';

// input related
export const INPUT_CLEAR = 'INPUT_CLEAR';
export const INPUT_CHANGE = 'INPUT_CHANGE';

// bulk related
export const BULK_UPLOAD_FILE_DELETED = 'BULK_UPLOAD_FILE_DELETED';
export const BULK_UPLOAD_VALID_FILE = 'BULK_UPLOAD_VALID_FILE';
export const BULK_UPLOAD_PROCESSING_PROMPT = 'BULK_UPLOAD_PROCESSING_PROMPT';
export const BULK_UPLOAD_PROCESSING_BEGIN = 'BULK_UPLOAD_PROCESSING_BEGIN';
export const BULK_UPLOAD_PROCESSING_COMPLETE = 'BULK_UPLOAD_PROCESSING_COMPLETE';
export const BULK_UPLOAD_PROCESSING_ERROR = 'BULK_UPLOAD_PROCESSING_ERROR';
export const BULK_UPLOAD_BEGIN_TOKENIZING = 'BULK_UPLOAD_BEGIN_TOKENIZING';
export const BULK_UPLOAD_BEGIN_CHUNKING = 'BULK_UPLOAD_BEGIN_CHUNKING';
export const BULK_UPLOAD_GET_NEXT_CHUNK = 'BULK_UPLOAD_GET_NEXT_CHUNK';
export const BULK_UPLOAD_SEND_CHUNK = 'BULK_UPLOAD_SEND_CHUNK';
export const BULK_UPLOAD_CHUNKING_COMPLETE = 'BULK_UPLOAD_CHUNKING_COMPLETE';

// generic error related
export const USE_USER_PROVIDED_STYLE = 'USE_USER_PROVIDED_STYLE';
export const USE_DEFAULT_STYLE = 'USE_DEFAULT_STYLE';
export const USE_ERROR_STYLE = 'USE_ERROR_STYLE';
export const USE_INACTIVE_STYLE = 'USE_INACTIVE_STYLE';
export const USE_READ_ONLY_STYLE = 'USE_READ_ONLY_STYLE';
